@for (warning of promoPageContent.EditorialWarningMessages; track warning) {
    <div class="custom-error">
        <span>{{ warning }}</span>
    </div>
}

@if (promoPageContent.ContentEditorUrl && promoPageContent.PageEditorUrl && promoPageMetaData.ShowSitecoreNavButtons) {
    <div>
        <a target="_blank" [href]="promoPageContent.ContentEditorUrl" class="btn btn-primary">Content Editor</a>
        <a target="_blank" [href]="promoPageContent.PageEditorUrl" class="btn btn-primary">Page Editor</a>
    </div>
}

@if (promoPageContent.IsCollapsibleContainer) {
    @switch (contentState) {
        @case ('success') {
            <collapsible-container
                [sitecoreHtml]="promoPageContent.SitecoreHtml"
                [h2Header]="promoPageContent.H2Header"
                [h1Header]="promoPageContent.H1Header"></collapsible-container>
        }
        @case ('notfound') {
            <vn-page-matrix path="App-v1.0/partials/notfound"></vn-page-matrix>
        }
        @case ('criticalError') {
            <vn-page-matrix path="App-v1.0/partials/criticalError"></vn-page-matrix>
        }
    }
}
@if (!promoPageContent.IsCollapsibleContainer) {
    @switch (contentState) {
        @case ('success') {
            <div [vnDynamicHtml]="promoPageContent.SitecoreHtml"></div>
        }
        @case ('notfound') {
            <vn-page-matrix path="App-v1.0/partials/notfound"></vn-page-matrix>
        }
        @case ('criticalError') {
            <vn-page-matrix path="App-v1.0/partials/criticalError"></vn-page-matrix>
        }
    }
}
